import { DateInterval } from '../enums/date-interval.enum';

export type DateIntervalKeyPair = {
  [key in DateInterval]: string;
};

export const DropdownDateIntervalLabel: DateIntervalKeyPair = {
  [DateInterval.Day]: '24 hours',
  [DateInterval.Week]: '1 week',
  [DateInterval.Month]: '1 month',
  [DateInterval.Half]: '6 months',
  [DateInterval.Last3Hours]: 'Last 3 hours',
  [DateInterval.Last6Hours]: 'Last 6 hours',
  [DateInterval.Last12Hours]: 'Last 12 hours',
  [DateInterval.Today]: 'Today',
  [DateInterval.Yesterday]: 'Yesterday',
};

export const ButtonDateIntervalLabel: DateIntervalKeyPair = {
  [DateInterval.Day]: '1D',
  [DateInterval.Week]: '1W',
  [DateInterval.Month]: '1M',
  [DateInterval.Half]: '6M',
  [DateInterval.Last3Hours]: '3H',
  [DateInterval.Last6Hours]: '6H',
  [DateInterval.Last12Hours]: '12H',
  [DateInterval.Today]: 'Today',
  [DateInterval.Yesterday]: 'Yesterday',
};